import { motion } from "framer-motion";
import { ShoppingBagOpen, Storefront } from "@phosphor-icons/react";
import { SiteTopBar } from "../components/site/SiteTopBar";
import { Footer } from "../components/site/Footer";
import { AppBadges } from "../components/site/AppBadges";
import { fadeUp, stagger, viewport } from "../lib/motion";
import { consumerFeatures, lojistaFeatures } from "../lib/recursos";
import { ADMIN_URL } from "../lib/site";

const FeatureGrid = ({ features, accentBg, accentText }) => (
  <motion.div
    variants={stagger}
    initial="hidden"
    whileInView="show"
    viewport={viewport}
    className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
  >
    {features.map((f) => (
      <motion.div
        key={f.title}
        variants={fadeUp}
        className="group flex items-start gap-4 rounded-2xl border border-black/5 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
      >
        <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${accentBg} transition-transform duration-300 group-hover:scale-110`}>
          <f.icon size={26} weight="duotone" className={accentText} />
        </span>
        <div>
          <h3 className="font-display text-lg font-bold text-maraca-navy">{f.title}</h3>
          <p className="mt-1 text-sm leading-relaxed text-maraca-navy/70">{f.desc}</p>
        </div>
      </motion.div>
    ))}
  </motion.div>
);

export default function Recursos() {
  return (
    <div className="min-h-screen bg-white">
      <SiteTopBar />

      <section className="relative overflow-hidden bg-white pt-32 md:pt-40" data-testid="recursos-page">
        <div className="pointer-events-none absolute -right-32 top-10 h-80 w-80 rounded-full bg-maraca-amber/15 blur-3xl" />
        <div className="mx-auto max-w-8xl px-5 md:px-10">
          <p className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-maraca-amber">
            Recursos do Delivery Maracás
          </p>
          <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-tight text-maraca-navy md:text-5xl lg:text-6xl">
            Tudo o que o app faz por você
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-maraca-navy/70">
            Do pedido em tempo real ao painel completo do lojista: conheça os recursos que tornam
            o Delivery Maracás mais prático, econômico e completo.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-8xl px-5 md:px-10">
          <div className="mb-10 flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-maraca-teal/10">
              <ShoppingBagOpen size={24} weight="duotone" className="text-maraca-teal" />
            </span>
            <h2 className="font-display text-3xl font-extrabold tracking-tight text-maraca-navy md:text-4xl">
              Para o consumidor
            </h2>
          </div>
          <FeatureGrid features={consumerFeatures} accentBg="bg-maraca-teal/10" accentText="text-maraca-teal" />
          <div className="mt-10">
            <AppBadges />
          </div>
        </div>
      </section>

      <section className="bg-slate-50 py-16 md:py-24">
        <div className="mx-auto max-w-8xl px-5 md:px-10">
          <div className="mb-10 flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-maraca-amber/15">
              <Storefront size={24} weight="duotone" className="text-maraca-amber" />
            </span>
            <h2 className="font-display text-3xl font-extrabold tracking-tight text-maraca-navy md:text-4xl">
              Para o lojista
            </h2>
          </div>
          <FeatureGrid features={lojistaFeatures} accentBg="bg-maraca-amber/15" accentText="text-maraca-amber" />
          <a
            href={ADMIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="recursos-lojista-cta"
            className="mt-10 inline-flex rounded-full bg-maraca-navy px-6 py-3.5 font-display text-base font-bold text-white transition-transform duration-300 hover:-translate-y-1"
          >
            Cadastre sua loja
          </a>
        </div>
      </section>

      <section className="bg-maraca-navy py-16 text-center text-white">
        <div className="mx-auto max-w-3xl px-5">
          <h2 className="font-display text-3xl font-extrabold tracking-tight md:text-4xl">
            Delivery Maracás na palma da mão
          </h2>
          <p className="mt-3 text-white/70">Mais praticidade, economia e facilidade para pedir.</p>
          <AppBadges className="mt-6 justify-center" />
        </div>
      </section>

      <Footer />
    </div>
  );
}
